








import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { DxDataGrid, DxColumn } from 'devextreme-vue/data-grid';
import { DataSource } from '@/types';
import { TableConfig, defaultTableConfig, columnTemplates } from '@/core/components/table';

@Component({
    components: {
        DxDataGrid,
        DxColumn,
    },
})
export default class ConsumptionPerformanceTable extends Vue {
    @Prop({ type: [Array, Object], required: true }) public dataSource!: DataSource;

    public get defaultTableConfig(): Partial<TableConfig> {
        return defaultTableConfig(this);
    }

    public get columnTemplates() {
        return columnTemplates;
    }
}
